<template>
  <Grid gtr="auto 1fr" gap="var(--r-space-lg)" class="total-overview bg-white-1 shadow3 q-pa-lg q-pr-xl q-pb-xl">
    <TitleSection :data="overviewData" />

    <Grid gtc="repeat(2, minmax(275px, 1fr))" gap="12px">
      <ChartSection :data="overviewData" />
      <PricesInfoSection :data="overviewData" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState, mapActions } from 'vuex'
// Components
import TitleSection from './TitleSection'
import ChartSection from './ChartSection'
import PricesInfoSection from './PricesInfoSection'

export default {
  components: {
    TitleSection,
    ChartSection,
    PricesInfoSection
  },

  computed: {
    ...mapState('predictions', ['financialPeriodId']),
    ...mapState('price-forecast', ['overviewData'])
  },

  watch: {
    financialPeriodId: {
      handler: 'getAndSetOverviewData',
      immediate: true
    }
  },

  methods: {
    ...mapActions('price-forecast', ['getAndSetOverviewData'])
  }
}
</script>

<style lang="scss" scoped>
.total-overview {
  grid-area: total-overview;
  height: 290px;
}
</style>
